<template>
  <div class="singersonglist">
    <div class="comp-title">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Bài hát
        </h1>
      </div>
    </div>
    <div style="clear:both;"></div>

    <div class="content">
      <div v-for="item in dataList" class="col-md-6 float-left item">
        <a :href="prefixUrl + item.id + '/' + convertToAlias(item.song)">
          <img class="thumbnail" :src="item.thumbnail != '' ? item.thumbnail : defaultThumbnail"/>
          <h4 class="song color-text">{{ item.song }}</h4>
          <p class="singer color-text">{{ item.singer }}</p>
          <p class="viewcount font-size-13 color-text">
            <span class="color-text font-weight-bold codesong">Mã: {{ item.code }}</span>
          </p>
        </a>
      </div>
      <div style="clear: both;"></div>

      <pagination-2
        :total-pages="totalPage"
        :total="totalRecord"
        :per-page="10"
        :current-page="currentPage"
        @pagechanged="onPageChange"
        :previous-name="previousName"
        :next-name="nextName"
      >
      </pagination-2>
    </div>
  </div>
</template>

<script>
  import Pagination2 from '../../Pagination2'
  export default {
    name: "SingerSong",
    components: {
      'pagination-2': Pagination2
    },
    data () {
      return {
        defaultThumbnail: this.settings.defaultThumbnailSong,
        prefixUrl: this.settings.prefixSong,
        currentPage: 1,
        totalRecord: 1,
        totalPage: 1,
        previousName: "previousArrow",
        nextName: "nextArrow",
        dataList: []
      }
    },
    methods: {
      getDataList(){
        var dataPost = {
          "singerCode": this.$route.params.code,
          "pageSize": 10,
          "pageIndex": this.currentPage
        };
        axios.post(api.songListBySinger, dataPost)
          .then(response => {
            this.dataList = response.data.result;
            this.totalRecord = response.data.totalRecord;
            this.totalPage = response.data.totalPage;
          }).catch(error => {
            console.log(error);
        });
      },
      onPageChange(page){
        this.currentPage = page;
      }
    },
    watch: {
      "currentPage": {
        handler: "getDataList",
        immediate: true
      },
      "$route.path": {
        handler: function (val) {
          this.getDataList();
          this.currentPage = 1;
        },
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .content{
    margin-top: 10px !important;
    text-align: left;
  }
  .thumbnail{
    float: left;
    margin-right: 5px;
    width: 60px;
    height: 60px;
  }
  .item{
    position: relative;
    margin-bottom: 1rem;
  }
  .viewcount{
    position: absolute;
    top: 0.5rem;
    right: 3rem;
  }
  .codesong{
    background-color: #ececec;
    padding: 0.5rem 1rem;
    border-radius: 30px;
  }
  .pagination{
    position: relative;
    top: 2rem;
    margin: 0 auto;
    text-align: center;
    display: block;
    margin-bottom: 5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/singerdetail/web/Song.vue